/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * ByteNite jobs API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.1
 * Contact: info@bytenite.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as url from "url";
import portableFetch from "portable-fetch";
import { Configuration } from "./configuration";

const BASE_PATH = "https://api.bytenite.com/v1/customer".replace(/\/+$/, "");
const WALLET_BASE_PATH = "https://api.bytenite.com/v1/wallet".replace(
  /\/+$/,
  ""
);

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
  csv: ",",
  ssv: " ",
  tsv: "\t",
  pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
  (url: string, init?: any): Promise<Response>;
}

/**
 *
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
  url: string;
  options: any;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
  protected configuration: Configuration;

  constructor(
    configuration?: Configuration,
    protected basePath: string = BASE_PATH,
    protected fetch: FetchAPI = portableFetch,
    protected walletBasePath: string = WALLET_BASE_PATH
  ) {
    if (configuration) {
      this.configuration = configuration;
      this.basePath = configuration.basePath || this.basePath;
      this.walletBasePath = configuration.walletBasePath || this.walletBasePath;
    }
  }
}

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
  name: "RequiredError";
  constructor(public field: string, msg?: string) {
    super(msg);
  }
}

/**
 *
 * @export
 * @interface BytenitecustomerServerInfoResponse
 */
export interface BytenitecustomerServerInfoResponse {
  /**
   *
   * @type {CommonVersion}
   * @memberof BytenitecustomerServerInfoResponse
   */
  version?: CommonVersion;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof BytenitecustomerServerInfoResponse
   */
  messages?: { [key: string]: string };
}

/**
 *
 * @export
 * @interface BytenitewalletTransaction
 */
export interface BytenitewalletTransaction {
  /**
   *
   * @type {string}
   * @memberof BytenitewalletTransaction
   */
  id?: string;
  /**
   *
   * @type {Date}
   * @memberof BytenitewalletTransaction
   */
  createdAt?: Date;
  /**
   *
   * @type {string}
   * @memberof BytenitewalletTransaction
   */
  accountFrom?: string;
  /**
   *
   * @type {number}
   * @memberof BytenitewalletTransaction
   */
  accountTo?: string;
  /**
   *
   * @type {string}
   * @memberof BytenitewalletTransaction
   */
  amount?: number;
  /**
   *
   * @type {string}
   * @memberof BytenitewalletTransaction
   */
  transactionType?: string;
  /**
   *
   * @type {CommonEntity}
   * @memberof BytenitewalletTransaction
   */
  relatedEntity?: CommonEntity;
  /**
   *
   * @type {string}
   * @memberof BytenitewalletTransaction
   */
  notes?: string;
  /**
   *
   * @type {ProtobufAny}
   * @memberof BytenitewalletTransaction
   */
  transactionData?: ProtobufAny;
  /**
   *
   * @type {string}
   * @memberof BytenitewalletTransaction
   */
  hash?: string;
}

/**
 *
 * @export
 * @interface CommonEntity
 */
export interface CommonEntity {
  /**
   *
   * @type {string}
   * @memberof CommonEntity
   */
  type?: string;
  /**
   *
   * @type {string}
   * @memberof CommonEntity
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof CommonEntity
   */
  name?: string;
}

/**
 *
 * @export
 * @interface CommonError
 */
export interface CommonError {
  /**
   *
   * @type {number}
   * @memberof CommonError
   */
  code?: number;
  /**
   *
   * @type {string}
   * @memberof CommonError
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof CommonError
   */
  description?: string;
}

/**
 *
 * @export
 * @interface CommonFilter
 */
export interface CommonFilter {
  /**
   *
   * @type {string}
   * @memberof CommonFilter
   */
  field?: string;
  /**
   *
   * @type {CommonFilterCondition}
   * @memberof CommonFilter
   */
  condition?: CommonFilterCondition;
  /**
   *
   * @type {ProtobufAny}
   * @memberof CommonFilter
   */
  value?: ProtobufAny;
}

/**
 *
 * @export
 * @enum {string}
 */
export enum CommonFilterCondition {
  EQ = <any>"FILTER_CONDITION_EQ",
  NEQ = <any>"FILTER_CONDITION_NEQ",
  GT = <any>"FILTER_CONDITION_GT",
  GTE = <any>"FILTER_CONDITION_GTE",
  LT = <any>"FILTER_CONDITION_LT",
  LTE = <any>"FILTER_CONDITION_LTE",
  ARRAYCONTAINS = <any>"FILTER_CONDITION_ARRAY_CONTAINS",
  ARRAYCONTAINSANY = <any>"FILTER_CONDITION_ARRAY_CONTAINS_ANY",
  IN = <any>"FILTER_CONDITION_IN",
  NOTIN = <any>"FILTER_CONDITION_NOT_IN",
  LIKE = <any>"FILTER_CONDITION_LIKE",
}

/**
 *
 * @export
 * @interface CommonGenericResponse
 */
export interface CommonGenericResponse {
  /**
   *
   * @type {boolean}
   * @memberof CommonGenericResponse
   */
  ok?: boolean;
  /**
   *
   * @type {string}
   * @memberof CommonGenericResponse
   */
  requestId?: string;
  /**
   *
   * @type {string}
   * @memberof CommonGenericResponse
   */
  message?: string;
  /**
   *
   * @type {CommonError}
   * @memberof CommonGenericResponse
   */
  error?: CommonError;
}

/**
 *
 * @export
 * @interface CommonLimitOffsetPagination
 */
export interface CommonLimitOffsetPagination {
  /**
   *
   * @type {number}
   * @memberof CommonLimitOffsetPagination
   */
  limit?: number;
  /**
   *
   * @type {number}
   * @memberof CommonLimitOffsetPagination
   */
  offset?: number;
}

/**
 *
 * @export
 * @interface CommonPaginatedResponse
 */
export interface CommonPaginatedResponse {
  /**
   *
   * @type {number}
   * @memberof CommonPaginatedResponse
   */
  total?: number;
  /**
   *
   * @type {number}
   * @memberof CommonPaginatedResponse
   */
  offset?: number;
  /**
   *
   * @type {boolean}
   * @memberof CommonPaginatedResponse
   */
  hasPrevious?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CommonPaginatedResponse
   */
  hasNext?: boolean;
}

/**
 *
 * @export
 * @interface CommonSelectionList
 */
export interface CommonSelectionList {
  /**
   *
   * @type {Array<string>}
   * @memberof CommonSelectionList
   */
  blacklist?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof CommonSelectionList
   */
  whitelist?: Array<string>;
}

/**
 *
 * @export
 * @interface CommonVersion
 */
export interface CommonVersion {
  /**
   *
   * @type {number}
   * @memberof CommonVersion
   */
  major?: number;
  /**
   *
   * @type {number}
   * @memberof CommonVersion
   */
  minor?: number;
  /**
   *
   * @type {string}
   * @memberof CommonVersion
   */
  tag?: string;
}

/**
 *
 * @export
 * @interface CustomerCancelTopUpRequestParams
 */
export interface CustomerCancelTopUpRequestParams {
  /**
   *
   * @type {string}
   * @memberof CustomerCancelTopUpRequestParams
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof CustomerCancelTopUpRequestParams
   */
  cancelMessage?: string;
}

/**
 *
 * @export
 * @interface CustomerEvent
 */
export interface CustomerEvent {
  /**
   *
   * @type {string}
   * @memberof CustomerEvent
   */
  event?: string;
  /**
   *
   * @type {ProtobufAny}
   * @memberof CustomerEvent
   */
  data?: ProtobufAny;
}

/**
 *
 * @export
 * @interface CustomerJobsRunningTasksRequest
 */
export interface CustomerJobsRunningTasksRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof CustomerJobsRunningTasksRequest
   */
  jobsIds?: Array<string>;
}

/**
 *
 * @export
 * @interface CustomerJobsRunningTasksResponse
 */
export interface CustomerJobsRunningTasksResponse {
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof CustomerJobsRunningTasksResponse
   */
  jobsRunningTasks?: { [key: string]: string };
}

/**
 *
 * @export
 * @interface CustomerQuery
 */
export interface CustomerQuery {
  /**
   *
   * @type {Array<CommonFilter>}
   * @memberof CustomerQuery
   */
  filters?: Array<CommonFilter>;
  /**
   *
   * @type {string}
   * @memberof CustomerQuery
   */
  orderBy?: string;
  /**
   *
   * @type {CommonLimitOffsetPagination}
   * @memberof CustomerQuery
   */
  pagination?: CommonLimitOffsetPagination;
}

/**
 *
 * @export
 * @interface CustomerRedeemCouponResponse
 */
export interface CustomerRedeemCouponResponse {
  /**
   *
   * @type {string}
   * @memberof CustomerRedeemCouponResponse
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof CustomerRedeemCouponResponse
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CustomerRedeemCouponResponse
   */
  amount?: string;
}

/**
 *
 * @export
 * @interface CustomerSchemaResponse
 */
export interface CustomerSchemaResponse {
  /**
   *
   * @type {string}
   * @memberof CustomerSchemaResponse
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof CustomerSchemaResponse
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof CustomerSchemaResponse
   */
  version?: string;
  /**
   *
   * @type {any}
   * @memberof CustomerSchemaResponse
   */
  schema?: any;
}

/**
 *
 * @export
 * @interface CustomerTopUpRequestParams
 */
export interface CustomerTopUpRequestParams {
  /**
   *
   * @type {string}
   * @memberof CustomerTopUpRequestParams
   */
  currencyAmount?: string;
  /**
   *
   * @type {string}
   * @memberof CustomerTopUpRequestParams
   */
  currency?: string;
  /**
   *
   * @type {string}
   * @memberof CustomerTopUpRequestParams
   */
  amount?: string;
}

/**
 *
 * @export
 * @interface DataSourceDataSource
 */
export interface DataSourceDataSource {
  /**
   *
   * @type {string}
   * @memberof DataSourceDataSource
   */
  dataSourceDescriptor?: string;
  /**
   *
   * @type {ProtobufAny}
   * @memberof DataSourceDataSource
   */
  params?: ProtobufAny;
}

/**
 *
 * @export
 * @interface JobAppParams
 */
export interface JobAppParams {
  /**
   *
   * @type {string}
   * @memberof JobAppParams
   */
  schema?: string;
  /**
   *
   * @type {any}
   * @memberof JobAppParams
   */
  data?: any;
  /**
   *
   * @type {string}
   * @memberof JobAppParams
   */
  preset?: string;
  /**
   *
   * @type {Array<number>}
   * @memberof JobAppParams
   */
  selectedOutputs?: Array<number>;
}

/**
 *
 * @export
 * @interface JobAppRange
 */
export interface JobAppRange {
  /**
   *
   * @type {string}
   * @memberof JobAppRange
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof JobAppRange
   */
  platform?: string;
  /**
   *
   * @type {CommonVersion}
   * @memberof JobAppRange
   */
  minVersion?: CommonVersion;
  /**
   *
   * @type {CommonVersion}
   * @memberof JobAppRange
   */
  maxVersion?: CommonVersion;
}

/**
 *
 * @export
 * @enum {string}
 */
export enum JobByteLevel {
  UNDEFINED = <any>"EXECUTION_PRIORITY_UNDEFINED",
  CHEAP = <any>"EXECUTION_PRIORITY_CHEAP",
  BALANCED = <any>"EXECUTION_PRIORITY_BALANCED",
  FAST = <any>"EXECUTION_PRIORITY_FAST",
}

/**
 *
 * @export
 * @interface JobJob
 */
export interface JobJob {
  /**
   *
   * @type {string}
   * @memberof JobJob
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof JobJob
   */
  templateId?: string;
  /**
   *
   * @type {string}
   * @memberof JobJob
   */
  name?: string;
  /**
   *
   * @type {JobJobConfig}
   * @memberof JobJob
   */
  config?: JobJobConfig;
  /**
   *
   * @type {JobByteLevel}
   * @memberof JobJob
   */
  priority?: JobByteLevel;
  /**
   *
   * @type {Date}
   * @memberof JobJob
   */
  startAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof JobJob
   */
  deadline?: Date;
  /**
   *
   * @type {Date}
   * @memberof JobJob
   */
  submittedAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof JobJob
   */
  startedAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof JobJob
   */
  completedAt?: Date;
  /**
   *
   * @type {CommonSelectionList}
   * @memberof JobJob
   */
  regions?: CommonSelectionList;
  /**
   *
   * @type {JobJobState}
   * @memberof JobJob
   */
  state?: JobJobState;
  /**
   *
   * @type {DataSourceDataSource}
   * @memberof JobJob
   */
  dataSource?: DataSourceDataSource;
  /**
   *
   * @type {JobAppParams}
   * @memberof JobJob
   */
  params?: JobAppParams;
  /**
   *
   * @type {DataSourceDataSource}
   * @memberof JobJob
   */
  dataDestination?: DataSourceDataSource;
  /**
   *
   * @type {string}
   * @memberof JobJob
   */
  duration?: string;
  /**
   *
   * @type {Date}
   * @memberof JobJob
   */
  deletedAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof JobJob
   */
  createdAt?: Date;
  /**
   *
   * @type {string}
   * @memberof JobJob
   */
  paymentAmount?: string;
  /**
   *
   * @type {string}
   * @memberof JobJob
   */
  numUnitsEstimation?: string;
  /**
   *
   * @type {string}
   * @memberof JobJob
   */
  numChunks?: string;
  /**
   *
   * @type {string}
   * @memberof JobJob
   */
  errorMessage?: string;
}

/**
 *
 * @export
 * @interface JobJobConfig
 */
export interface JobJobConfig {
  /**
   *
   * @type {string}
   * @memberof JobJobConfig
   */
  minChunkSize?: string;
  /**
   *
   * @type {string}
   * @memberof JobJobConfig
   */
  maxChunkSize?: string;
  /**
   *
   * @type {number}
   * @memberof JobJobConfig
   */
  replicationFactor?: number;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof JobJobConfig
   */
  partitioningSettings?: { [key: string]: string };
}

/**
 *
 * @export
 * @enum {string}
 */
export enum JobJobState {
  NEW = <any>"JOB_STATE_NEW",
  UPLOADING = <any>"JOB_STATE_UPLOADING",
  PARTITIONING = <any>"JOB_STATE_PARTITIONING",
  PARTITIONED = <any>"JOB_STATE_PARTITIONED",
  QUEUED = <any>"JOB_STATE_QUEUED",
  MERGING = <any>"JOB_STATE_MERGING",
  MERGED = <any>"JOB_STATE_MERGED",
  DOWNLOADING = <any>"JOB_STATE_DOWNLOADING",
  COMPLETE = <any>"JOB_STATE_COMPLETE",
  FAILED = <any>"JOB_STATE_FAILED",
  TASKS_COMPLETED=<any>"JOB_STATE_TASKS_COMPLETED"
}

/**
 *
 * @export
 * @interface JobJobTemplate
 */
export interface JobJobTemplate {
  /**
   *
   * @type {string}
   * @memberof JobJobTemplate
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof JobJobTemplate
   */
  name?: string;
  /**
   *
   * @type {Array<JobAppRange>}
   * @memberof JobJobTemplate
   */
  apps?: Array<JobAppRange>;
  /**
   *
   * @type {JobJobConfig}
   * @memberof JobJobTemplate
   */
  defaultConfig?: JobJobConfig;
  /**
   *
   * @type {string}
   * @memberof JobJobTemplate
   */
  partitioningStrategy?: string;
  /**
   *
   * @type {string}
   * @memberof JobJobTemplate
   */
  mergeStrategy?: string;
  /**
   *
   * @type {string}
   * @memberof JobJobTemplate
   */
  dataType?: string;
  /**
   *
   * @type {boolean}
   * @memberof JobJobTemplate
   */
  streamable?: boolean;
  /**
   *
   * @type {string}
   * @memberof JobJobTemplate
   */
  minCapacity?: string;
  /**
   *
   * @type {string}
   * @memberof JobJobTemplate
   */
  weight?: string;
  /**
   *
   * @type {ProtobufAny}
   * @memberof JobJobTemplate
   */
  schema?: ProtobufAny;
}

/**
 * If job id already exists and the request hasn't started the job record is updated, if job id is null a new id is generated.
 * @export
 * @interface JobsCreateJobRequest
 */
export interface JobsCreateJobRequest {
  /**
   *
   * @type {string}
   * @memberof JobsCreateJobRequest
   */
  jobId?: string;
  /**
   *
   * @type {string}
   * @memberof JobsCreateJobRequest
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof JobsCreateJobRequest
   */
  templateId: string;
  /**
   *
   * @type {string}
   * @memberof JobsCreateJobRequest
   */
  description?: string;
  /**
   *
   * @type {DataSourceDataSource}
   * @memberof JobsCreateJobRequest
   */
  dataSource?: DataSourceDataSource;
  /**
   *
   * @type {DataSourceDataSource}
   * @memberof JobsCreateJobRequest
   */
  dataDestination?: DataSourceDataSource;
  /**
   *
   * @type {JobAppParams}
   * @memberof JobsCreateJobRequest
   */
  params?: JobAppParams;
}

/**
 *
 * @export
 * @interface JobsDataSourceInfoRequest
 */
export interface JobsDataSourceInfoRequest {
  /**
   *
   * @type {DataSourceDataSource}
   * @memberof JobsDataSourceInfoRequest
   */
  dataSource?: DataSourceDataSource;
  /**
   *
   * @type {boolean}
   * @memberof JobsDataSourceInfoRequest
   */
  listFiles?: boolean;
}

/**
 *
 * @export
 * @interface JobsDataSourceInfoResponse
 */
export interface JobsDataSourceInfoResponse {
  /**
   *
   * @type {string}
   * @memberof JobsDataSourceInfoResponse
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof JobsDataSourceInfoResponse
   */
  filename?: string;
  /**
   *
   * @type {string}
   * @memberof JobsDataSourceInfoResponse
   */
  path?: string;
  /**
   *
   * @type {string}
   * @memberof JobsDataSourceInfoResponse
   */
  size?: string;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof JobsDataSourceInfoResponse
   */
  properties?: { [key: string]: string };
  /**
   *
   * @type {string}
   * @memberof JobsDataSourceInfoResponse
   */
  tempUrl?: string;
  /**
   *
   * @type {JobsDirectory}
   * @memberof JobsDataSourceInfoResponse
   */
  files?: JobsDirectory;
}

/**
 *
 * @export
 * @interface JobsDataSourceParams
 */
export interface JobsDataSourceParams {
  /**
   *
   * @type {DataSourceDataSource}
   * @memberof JobsDataSourceParams
   */
  dataSource?: DataSourceDataSource;
  /**
   *
   * @type {DataSourceDataSource}
   * @memberof JobsDataSourceParams
   */
  dataDestination?: DataSourceDataSource;
}

/**
 *
 * @export
 * @interface JobsDirectory
 */
export interface JobsDirectory {
  /**
   *
   * @type {string}
   * @memberof JobsDirectory
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof JobsDirectory
   */
  path?: string;
  /**
   *
   * @type {Array<JobsDirectory>}
   * @memberof JobsDirectory
   */
  directories?: Array<JobsDirectory>;
  /**
   *
   * @type {Array<JobsFile>}
   * @memberof JobsDirectory
   */
  files?: Array<JobsFile>;
}

/**
 *
 * @export
 * @interface JobsFile
 */
export interface JobsFile {
  /**
   *
   * @type {string}
   * @memberof JobsFile
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof JobsFile
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof JobsFile
   */
  path?: string;
  /**
   *
   * @type {string}
   * @memberof JobsFile
   */
  size?: string;
}

/**
 *
 * @export
 * @interface JobsJobEstimationResponse
 */
export interface JobsJobEstimationResponse {
  /**
   *
   * @type {PartitionerEstimateJobResponse}
   * @memberof JobsJobEstimationResponse
   */
  estimation?: PartitionerEstimateJobResponse;
}

/**
 *
 * @export
 * @interface JobsJobPreset
 */
export interface JobsJobPreset {
  /**
   *
   * @type {string}
   * @memberof JobsJobPreset
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof JobsJobPreset
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof JobsJobPreset
   */
  category?: string;
  /**
   *
   * @type {string}
   * @memberof JobsJobPreset
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof JobsJobPreset
   */
  jobTemplateId?: string;
  /**
   *
   * @type {any}
   * @memberof JobsJobPreset
   */
  params?: any;
}

/**
 *
 * @export
 * @interface JobsJobPresetsResponse
 */
export interface JobsJobPresetsResponse {
  /**
   *
   * @type {Array<JobsJobPreset>}
   * @memberof JobsJobPresetsResponse
   */
  presets?: Array<JobsJobPreset>;
}

/**
 *
 * @export
 * @interface JobsJobResponse
 */
export interface JobsJobResponse {
  /**
   *
   * @type {JobJob}
   * @memberof JobsJobResponse
   */
  job?: JobJob;
}

/**
 *
 * @export
 * @interface JobsJobResult
 */
export interface JobsJobResult {
  /**
   *
   * @type {string}
   * @memberof JobsJobResult
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof JobsJobResult
   */
  link?: string;
}

/**
 *
 * @export
 * @interface JobsJobResultsResponse
 */
export interface JobsJobResultsResponse {
  /**
   *
   * @type {Array<JobsJobResult>}
   * @memberof JobsJobResultsResponse
   */
  results?: Array<JobsJobResult>;
}

/**
 *
 * @export
 * @interface JobsJobTemplatesResponse
 */
export interface JobsJobTemplatesResponse {
  /**
   *
   * @type {CommonPaginatedResponse}
   * @memberof JobsJobTemplatesResponse
   */
  pagination?: CommonPaginatedResponse;
  /**
   *
   * @type {Array<JobJobTemplate>}
   * @memberof JobsJobTemplatesResponse
   */
  data?: Array<JobJobTemplate>;
}

/**
 *
 * @export
 * @interface JobsJobsResponse
 */
export interface JobsJobsResponse {
  /**
   *
   * @type {CommonPaginatedResponse}
   * @memberof JobsJobsResponse
   */
  pagination?: CommonPaginatedResponse;
  /**
   *
   * @type {Array<JobJob>}
   * @memberof JobsJobsResponse
   */
  data?: Array<JobJob>;
}

/**
 *
 * @export
 * @interface JobsRunJobParams
 */
export interface JobsRunJobParams {}

/**
 *
 * @export
 * @interface PartitionerEstimateJobResponse
 */
export interface PartitionerEstimateJobResponse {
  /**
   *
   * @type {Array<PartitionerOutputEstimation>}
   * @memberof PartitionerEstimateJobResponse
   */
  estimations?: Array<PartitionerOutputEstimation>;
  /**
   *
   * @type {string}
   * @memberof PartitionerEstimateJobResponse
   */
  totalEstimation?: string;
}

/**
 *
 * @export
 * @interface PartitionerOutputEstimation
 */
export interface PartitionerOutputEstimation {
  /**
   *
   * @type {JobJob}
   * @memberof PartitionerOutputEstimation
   */
  job?: JobJob;
  /**
   *
   * @type {number}
   * @memberof PartitionerOutputEstimation
   */
  unitaryCostEstimation?: number;
  /**
   *
   * @type {number}
   * @memberof PartitionerOutputEstimation
   */
  numUnitsEstimation?: number;
  /**
   *
   * @type {string}
   * @memberof PartitionerOutputEstimation
   */
  estimationFormatting?: string;
}

/**
 *
 * @export
 * @enum {string}
 */
export enum PlanPlanState {
  NEW = <any>"NEW",
  ENABLED = <any>"ENABLED",
  DISABLED = <any>"DISABLED",
}

/**
 *
 * @export
 * @enum {string}
 */
export enum PlanPlanType {
  UNKNOWN = <any>"UNKNOWN",
  SUBSCRIPTION = <any>"SUBSCRIPTION",
  STOCK = <any>"STOCK",
}

/**
 * 'Any' contains an arbitrary serialized protocol buffer message along with a URL that describes the type of the serialized message.  Protobuf library provides support to pack/unpack Any values in the form of utility functions or additional generated methods of the Any type.  Example 1: Pack and unpack a message in C++.      Foo foo = ...;     Any any;     any.PackFrom(foo);     ...     if (any.UnpackTo(&foo)) {       ...     }  Example 2: Pack and unpack a message in Java.      Foo foo = ...;     Any any = Any.pack(foo);     ...     if (any.is(Foo.class)) {       foo = any.unpack(Foo.class);     }   Example 3: Pack and unpack a message in Python.      foo = Foo(...)     any = Any()     any.Pack(foo)     ...     if any.Is(Foo.DESCRIPTOR):       any.Unpack(foo)       ...   Example 4: Pack and unpack a message in Go       foo := &pb.Foo{...}      any, err := anypb.New(foo)      if err != nil {        ...      }      ...      foo := &pb.Foo{}      if err := any.UnmarshalTo(foo); err != nil {        ...      }  The pack methods provided by protobuf library will by default use 'type.googleapis.com/full.type.name' as the type URL and the unpack methods only use the fully qualified type name after the last '/' in the type URL, for example \"foo.bar.com/x/y.z\" will yield type name \"y.z\".   JSON ==== The JSON representation of an 'Any' value uses the regular representation of the deserialized, embedded message, with an additional field '@type' which contains the type URL. Example:      package google.profile;     message Person {       string first_name = 1;       string last_name = 2;     }      {       \"@type\": \"type.googleapis.com/google.profile.Person\",       \"firstName\": <string>,       \"lastName\": <string>     }  If the embedded message type is well-known and has a custom JSON representation, that representation will be embedded adding a field 'value' which holds the custom JSON in addition to the '@type' field. Example (for message [google.protobuf.Duration][]):      {       \"@type\": \"type.googleapis.com/google.protobuf.Duration\",       \"value\": \"1.212s\"     }
 * @export
 * @interface ProtobufAny
 */
export interface ProtobufAny {
  [key: string]: any | any;

  /**
   * A URL/resource name that uniquely identifies the type of the serialized protocol buffer message. This string must contain at least one \"/\" character. The last segment of the URL's path must represent the fully qualified name of the type (as in 'path/google.protobuf.Duration'). The name should be in a canonical form (e.g., leading \".\" is not accepted).  In practice, teams usually precompile into the binary all types that they expect it to use in the context of Any. However, for URLs which use the scheme 'http', 'https', or no scheme, one can optionally set up a type server that maps type URLs to message definitions as follows:  * If no scheme is provided, 'https' is assumed. * An HTTP GET on the URL must yield a [google.protobuf.Type][]   value in binary format, or produce an error. * Applications are allowed to cache lookup results based on the   URL, or have them precompiled into a binary to avoid any   lookup. Therefore, binary compatibility needs to be preserved   on changes to types. (Use versioned type names to manage   breaking changes.)  Note: this functionality is not currently available in the official protobuf release, and it is not used for type URLs beginning with type.googleapis.com.  Schemes other than 'http', 'https' (or the empty scheme) might be used with implementation specific semantics.
   * @type {string}
   * @memberof ProtobufAny
   */
  type?: string;
}

/**
 * 'NullValue' is a singleton enumeration to represent the null value for the 'Value' type union.   The JSON representation for 'NullValue' is JSON 'null'.   - NULL_VALUE: Null value.
 * @export
 * @enum {string}
 */
export enum ProtobufNullValue {
  NULLVALUE = <any>"NULL_VALUE",
}

/**
 *
 * @export
 * @interface RpcStatus
 */
export interface RpcStatus {
  /**
   *
   * @type {number}
   * @memberof RpcStatus
   */
  code?: number;
  /**
   *
   * @type {string}
   * @memberof RpcStatus
   */
  message?: string;
  /**
   *
   * @type {Array<ProtobufAny>}
   * @memberof RpcStatus
   */
  details?: Array<ProtobufAny>;
}

/**
 *
 * @export
 * @interface StatsJobStatsResponse
 */
export interface StatsJobStatsResponse {}

/**
 *
 * @export
 * @interface StatsJobTypesResponse
 */
export interface StatsJobTypesResponse {}

/**
 *
 * @export
 * @interface StatsOverviewStatsRequest
 */
export interface StatsOverviewStatsRequest {
  /**
   *
   * @type {Date}
   * @memberof StatsOverviewStatsRequest
   */
  startDate?: Date;
  /**
   *
   * @type {Date}
   * @memberof StatsOverviewStatsRequest
   */
  endDate?: Date;
}

/**
 *
 * @export
 * @interface StatsOverviewStatsResponse
 */
export interface StatsOverviewStatsResponse {
  /**
   *
   * @type {string}
   * @memberof StatsOverviewStatsResponse
   */
  numVideosEncoded?: string;
  /**
   *
   * @type {string}
   * @memberof StatsOverviewStatsResponse
   */
  minVideosEncoded?: string;
  /**
   *
   * @type {string}
   * @memberof StatsOverviewStatsResponse
   */
  uploadVolume?: string;
  /**
   *
   * @type {string}
   * @memberof StatsOverviewStatsResponse
   */
  compressedVolume?: string;
  /**
   *
   * @type {string}
   * @memberof StatsOverviewStatsResponse
   */
  processingTime?: string;
  /**
   *
   * @type {string}
   * @memberof StatsOverviewStatsResponse
   */
  timeSaved?: string;
  /**
   *
   * @type {string}
   * @memberof StatsOverviewStatsResponse
   */
  bytechipsSpent?: string;
  /**
   *
   * @type {string}
   * @memberof StatsOverviewStatsResponse
   */
  bytechipsPurchased?: string;
}

/**
 *
 * @export
 * @interface StreamResultOfCustomerEvent
 */
export interface StreamResultOfCustomerEvent {
  /**
   *
   * @type {CustomerEvent}
   * @memberof StreamResultOfCustomerEvent
   */
  result?: CustomerEvent;
  /**
   *
   * @type {RpcStatus}
   * @memberof StreamResultOfCustomerEvent
   */
  error?: RpcStatus;
}

/**
 *
 * @export
 * @interface UpdateSubscriptionRequestUpdateSubscriptionRequestBody
 */
export interface UpdateSubscriptionRequestUpdateSubscriptionRequestBody {
  /**
   *
   * @type {string}
   * @memberof UpdateSubscriptionRequestUpdateSubscriptionRequestBody
   */
  amount?: string;
}

/**
 *
 * @export
 * @interface WalletCreateSubscriptionRequest
 */
export interface WalletCreateSubscriptionRequest {
  /**
   *
   * @type {string}
   * @memberof WalletCreateSubscriptionRequest
   */
  accountId?: string;
  /**
   *
   * @type {string}
   * @memberof WalletCreateSubscriptionRequest
   */
  ownerId?: string;
  /**
   *
   * @type {string}
   * @memberof WalletCreateSubscriptionRequest
   */
  amount?: string;
}

/**
 *
 * @export
 * @interface WalletCreateSubscriptionResponse
 */
export interface WalletCreateSubscriptionResponse {
  /**
   *
   * @type {WalletSubscription}
   * @memberof WalletCreateSubscriptionResponse
   */
  subscription?: WalletSubscription;
  /**
   *
   * @type {string}
   * @memberof WalletCreateSubscriptionResponse
   */
  clientSecret?: string;
  /**
   *
   * @type {boolean}
   * @memberof WalletCreateSubscriptionResponse
   */
  paid?: boolean;
}

/**
 *
 * @export
 * @interface WalletExchangeRateResponse
 */
export interface WalletExchangeRateResponse {
  /**
   *
   * @type {string}
   * @memberof WalletExchangeRateResponse
   */
  currency?: string;
  /**
   *
   * @type {string}
   * @memberof WalletExchangeRateResponse
   */
  currencyAmount?: string;
  /**
   *
   * @type {number}
   * @memberof WalletExchangeRateResponse
   */
  exchangeRate?: number;
  /**
   *
   * @type {string}
   * @memberof WalletExchangeRateResponse
   */
  amount?: string;
}

/**
 *
 * @export
 * @interface WalletGetBalanceResponse
 */
export interface WalletGetBalanceResponse {
  /**
   *
   * @type {string}
   * @memberof WalletGetBalanceResponse
   */
  accountId?: string;
  /**
   *
   * @type {string}
   * @memberof WalletGetBalanceResponse
   */
  totalBalance?: string;
  /**
   *
   * @type {string}
   * @memberof WalletGetBalanceResponse
   */
  availableBalance?: string;
  /**
   *
   * @type {string}
   * @memberof WalletGetBalanceResponse
   */
  subscriptionBalance?: string;
  /**
   *
   * @type {string}
   * @memberof WalletGetBalanceResponse
   */
  stockBalance?: string;
}

/**
 *
 * @export
 * @interface WalletListPlansResponse
 */
export interface WalletListPlansResponse {
  /**
   *
   * @type {Array<WalletPlan>}
   * @memberof WalletListPlansResponse
   */
  plans?: Array<WalletPlan>;
}

/**
 *
 * @export
 * @interface WalletPayoutRequest
 */
export interface WalletPayoutRequest {
  /**
   *
   * @type {string}
   * @memberof WalletPayoutRequest
   */
  id?: string;
  /**
   *
   * @type {Date}
   * @memberof WalletPayoutRequest
   */
  createdAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof WalletPayoutRequest
   */
  updatedAt?: Date;
  /**
   *
   * @type {string}
   * @memberof WalletPayoutRequest
   */
  ownerId?: string;
  /**
   *
   * @type {string}
   * @memberof WalletPayoutRequest
   */
  accountId?: string;
  /**
   *
   * @type {string}
   * @memberof WalletPayoutRequest
   */
  payoutProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof WalletPayoutRequest
   */
  amount?: string;
  /**
   *
   * @type {string}
   * @memberof WalletPayoutRequest
   */
  currency?: string;
  /**
   *
   * @type {string}
   * @memberof WalletPayoutRequest
   */
  currencyAmount?: string;
  /**
   *
   * @type {string}
   * @memberof WalletPayoutRequest
   */
  exchangeRate?: string;
  /**
   *
   * @type {WalletPayoutRequestState}
   * @memberof WalletPayoutRequest
   */
  state?: WalletPayoutRequestState;
  /**
   *
   * @type {Date}
   * @memberof WalletPayoutRequest
   */
  sentAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof WalletPayoutRequest
   */
  confirmedAt?: Date;
}

/**
 *
 * @export
 * @interface WalletPayoutRequestFilterResponse
 */
export interface WalletPayoutRequestFilterResponse {
  /**
   *
   * @type {string}
   * @memberof WalletPayoutRequestFilterResponse
   */
  accountId?: string;
  /**
   *
   * @type {Array<WalletPayoutRequest>}
   * @memberof WalletPayoutRequestFilterResponse
   */
  payoutRequests?: Array<WalletPayoutRequest>;
}

/**
 *
 * @export
 * @enum {string}
 */
export enum WalletPayoutRequestState {
  NEW = <any>"NEW",
  PENDINGVERIFICATION = <any>"PENDING_VERIFICATION",
  INFOREQUIRED = <any>"INFO_REQUIRED",
  SENT = <any>"SENT",
  CONFIRMED = <any>"CONFIRMED",
  BOUNCED = <any>"BOUNCED",
  FAILED = <any>"FAILED",
}

/**
 *
 * @export
 * @interface WalletPlan
 */
export interface WalletPlan {
  /**
   *
   * @type {string}
   * @memberof WalletPlan
   */
  id?: string;
  /**
   *
   * @type {Date}
   * @memberof WalletPlan
   */
  createdAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof WalletPlan
   */
  updatedAt?: Date;
  /**
   *
   * @type {PlanPlanState}
   * @memberof WalletPlan
   */
  state?: PlanPlanState;
  /**
   *
   * @type {string}
   * @memberof WalletPlan
   */
  amount?: string;
  /**
   *
   * @type {string}
   * @memberof WalletPlan
   */
  description?: string;
}

/**
 *
 * @export
 * @interface WalletRedeemCouponRequest
 */
export interface WalletRedeemCouponRequest {
  /**
   *
   * @type {string}
   * @memberof WalletRedeemCouponRequest
   */
  redeemedBy?: string;
  /**
   *
   * @type {string}
   * @memberof WalletRedeemCouponRequest
   */
  couponId?: string;
  /**
   *
   * @type {string}
   * @memberof WalletRedeemCouponRequest
   */
  couponCode?: string;
  /**
   *
   * @type {string}
   * @memberof WalletRedeemCouponRequest
   */
  amount?: string;
}

/**
 *
 * @export
 * @interface WalletRequirePayoutResponse
 */
export interface WalletRequirePayoutResponse {
  /**
   *
   * @type {WalletPayoutRequest}
   * @memberof WalletRequirePayoutResponse
   */
  payoutRequest?: WalletPayoutRequest;
}

/**
 *
 * @export
 * @interface WalletSubscription
 */
export interface WalletSubscription {
  /**
   *
   * @type {string}
   * @memberof WalletSubscription
   */
  id?: string;
  /**
   *
   * @type {Date}
   * @memberof WalletSubscription
   */
  createdAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof WalletSubscription
   */
  updatedAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof WalletSubscription
   */
  canceledAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof WalletSubscription
   */
  startedAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof WalletSubscription
   */
  nextRenewal?: Date;
  /**
   *
   * @type {Date}
   * @memberof WalletSubscription
   */
  deletedAt?: Date;
  /**
   *
   * @type {WalletSubscriptionState}
   * @memberof WalletSubscription
   */
  state?: WalletSubscriptionState;
  /**
   *
   * @type {string}
   * @memberof WalletSubscription
   */
  amount?: string;
  /**
   *
   * @type {string}
   * @memberof WalletSubscription
   */
  currencyAmount?: string;
  /**
   *
   * @type {string}
   * @memberof WalletSubscription
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof WalletSubscription
   */
  ownerId?: string;
  /**
   *
   * @type {string}
   * @memberof WalletSubscription
   */
  accountId?: string;
  /**
   *
   * @type {Date}
   * @memberof WalletSubscription
   */
  currentPeriodStart?: Date;
  /**
   *
   * @type {Date}
   * @memberof WalletSubscription
   */
  currentPeriodEnd?: Date;
  /**
   *
   * @type {string}
   * @memberof WalletSubscription
   */
  clientSecret?: string;
}

/**
 *
 * @export
 * @enum {string}
 */
export enum WalletSubscriptionState {
  NEW = <any>"NEW",
  ACTIVE = <any>"ACTIVE",
  UPDATEPENDING = <any>"UPDATE_PENDING",
  PAYMENTPENDING = <any>"PAYMENT_PENDING",
  PASTDUE = <any>"PAST_DUE",
  UNPAID = <any>"UNPAID",
  CANCELED = <any>"CANCELED",
  CANCELPENDING = <any>"CANCEL_PENDING",
  INCOMPLETE = <any>"INCOMPLETE",
  INCOMPLETEEXPIRED = <any>"INCOMPLETE_EXPIRED",
  TRIALING = <any>"TRIALING",
  PAUSED = <any>"PAUSED",
}

/**
 *
 * @export
 * @interface WalletTopUpRequest
 */
export interface WalletTopUpRequest {
  /**
   *
   * @type {string}
   * @memberof WalletTopUpRequest
   */
  id?: string;
  /**
   *
   * @type {Date}
   * @memberof WalletTopUpRequest
   */
  createdAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof WalletTopUpRequest
   */
  updatedAt?: Date;
  /**
   *
   * @type {string}
   * @memberof WalletTopUpRequest
   */
  ownerId?: string;
  /**
   *
   * @type {string}
   * @memberof WalletTopUpRequest
   */
  accountId?: string;
  /**
   *
   * @type {string}
   * @memberof WalletTopUpRequest
   */
  billingProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof WalletTopUpRequest
   */
  amount?: string;
  /**
   *
   * @type {string}
   * @memberof WalletTopUpRequest
   */
  currency?: string;
  /**
   *
   * @type {string}
   * @memberof WalletTopUpRequest
   */
  currencyAmount?: string;
  /**
   *
   * @type {string}
   * @memberof WalletTopUpRequest
   */
  exchangeRate?: string;
  /**
   *
   * @type {WalletTopUpRequestState}
   * @memberof WalletTopUpRequest
   */
  state?: WalletTopUpRequestState;
}

/**
 *
 * @export
 * @enum {string}
 */
export enum WalletTopUpRequestState {
  NEW = <any>"NEW",
  PENDING = <any>"PENDING",
  CONFIRMED = <any>"CONFIRMED",
  CANCELED = <any>"CANCELED",
  FAILED = <any>"FAILED",
}

/**
 *
 * @export
 * @interface WalletTopUpResponse
 */
export interface WalletTopUpResponse {
  /**
   *
   * @type {WalletTopUpRequest}
   * @memberof WalletTopUpResponse
   */
  topUpRequest?: WalletTopUpRequest;
  /**
   *
   * @type {string}
   * @memberof WalletTopUpResponse
   */
  clientSecret?: string;
}

/**
 *
 * @export
 * @interface WalletTransactionHistoryResponse
 */
export interface WalletTransactionHistoryResponse {
  /**
   *
   * @type {string}
   * @memberof WalletTransactionHistoryResponse
   */
  accountId?: string;
  /**
   *
   * @type {Array<BytenitewalletTransaction>}
   * @memberof WalletTransactionHistoryResponse
   */
  transactions?: Array<BytenitewalletTransaction>;
}

export type WalletTransactionResponse = {
  pagination: WalletTransactionPagination;
  data: WalletTransactionData[];
};

export type WalletTransactionData = {
  id: string;
  createdAt: Date;
  accountFrom: string;
  accountTo: string;
  amount: number;
  transactionType: string;
  relatedEntity: WalletTransactionRelatedEntity;
  notes: string;
  transactionData: null;
  hash: string;
  relatedEntityData: null;
  description: string;
};

export type WalletTransactionRelatedEntity = {
  type: string;
  id: string;
  name: string;
};

export type WalletTransactionPagination = {
  total: number;
  offset: number;
  hasPrevious: boolean;
  hasNext: boolean;
};
export interface TransactionHistory {
  pagination?: CommonPaginatedResponse;
  data?: Array<TransactionHistoryItem>;
}
export interface TransactionHistoryItem {
  id: string;
  createdAt: "2025-02-11T09:26:12.276Z";
  accountFrom: string;
  accountTo: string;
  amount: 0;
  transactionType: string;
  relatedEntity: {
    type: string;
    id: string;
    name: string;
  };
  notes: string;
  transactionData: {
    "@type": string;
    additionalProp1: string;
    additionalProp2: string;
    additionalProp3: string;
  };
  hash: string;
  relatedEntityData: {
    type: string;
    id: string;
    name: string;
    jobName: string;
    jobId: string;
    description: string;
    currency: string;
    currencyAmount: string;
    exchangeRate: number;
    couponCode: string;
  };
  description: string;
  balance: number;
}

/**
 * EventsApi - fetch parameter creator
 * @export
 */
export const EventsApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Listen events
     * @summary Listen events
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerEvents(options: any = {}): FetchArgs {
      const localVarPath = `/events`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EventsApi - functional programming interface
 * @export
 */
export const EventsApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Listen events
     * @summary Listen events
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerEvents(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<StreamResultOfCustomerEvent> {
      const localVarFetchArgs =
        EventsApiFetchParamCreator(configuration).customerEvents(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
  };
};

/**
 * EventsApi - factory interface
 * @export
 */
export const EventsApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     * Listen events
     * @summary Listen events
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerEvents(options?: any) {
      return EventsApiFp(configuration).customerEvents(options)(
        fetch,
        basePath
      );
    },
  };
};

/**
 * EventsApi - object-oriented interface
 * @export
 * @class EventsApi
 * @extends {BaseAPI}
 */
export class EventsApi extends BaseAPI {
  /**
   * Listen events
   * @summary Listen events
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApi
   */
  public customerEvents(options?: any) {
    return EventsApiFp(this.configuration).customerEvents(options)(
      this.fetch,
      this.basePath
    );
  }
}

/**
 * InfoApi - fetch parameter creator
 * @export
 */
export const InfoApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Server software version and important messages
     * @summary Retrieve information about server
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerInfo(options: any = {}): FetchArgs {
      const localVarPath = `/info`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * InfoApi - functional programming interface
 * @export
 */
export const InfoApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Server software version and important messages
     * @summary Retrieve information about server
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerInfo(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<BytenitecustomerServerInfoResponse> {
      const localVarFetchArgs =
        InfoApiFetchParamCreator(configuration).customerInfo(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
  };
};

/**
 * InfoApi - factory interface
 * @export
 */
export const InfoApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     * Server software version and important messages
     * @summary Retrieve information about server
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerInfo(options?: any) {
      return InfoApiFp(configuration).customerInfo(options)(fetch, basePath);
    },
  };
};

/**
 * InfoApi - object-oriented interface
 * @export
 * @class InfoApi
 * @extends {BaseAPI}
 */
export class InfoApi extends BaseAPI {
  /**
   * Server software version and important messages
   * @summary Retrieve information about server
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InfoApi
   */
  public customerInfo(options?: any) {
    return InfoApiFp(this.configuration).customerInfo(options)(
      this.fetch,
      this.basePath
    );
  }
}

/**
 * JobsApi - fetch parameter creator
 * @export
 */
export const JobsApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Abort running job (an incomplete job that is yet to start will be deleted)
     * @summary Stop a running job
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerAbortJob(id: string, options: any = {}): FetchArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          "id",
          "Required parameter id was null or undefined when calling customerAbortJob."
        );
      }
      const localVarPath = `/jobs/{id}/abort`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Create a job a new job with given template
     * @summary Create a new job
     * @param {JobsCreateJobRequest} body If job id already exists and the request hasn&#39;t started the job record is updated, if job id is null a new id is generated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerCreateJob(
      body: JobsCreateJobRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling customerCreateJob."
        );
      }
      const localVarPath = `/jobs`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"JobsCreateJobRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get info about a data source
     * @summary Get info about a data source
     * @param {JobsDataSourceInfoRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerDataSourceInfo(
      body: JobsDataSourceInfoRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling customerDataSourceInfo."
        );
      }
      const localVarPath = `/datasource/info`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"JobsDataSourceInfoRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Delete a job
     * @summary Delete a job
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerDeleteJob(id: string, options: any = {}): FetchArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          "id",
          "Required parameter id was null or undefined when calling customerDeleteJob."
        );
      }
      const localVarPath = `/jobs/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "DELETE" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get all jobs for user
     * @summary Get jobs
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetAll(
      limit?: number,
      offset?: number,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/jobs`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get all jobs for user and filter them
     * @summary Get jobs filtered
     * @param {CustomerQuery} query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetAllFiltered(query: CustomerQuery, options: any = {}): FetchArgs {
      // verify required parameter 'query' is not null or undefined
      if (query === null || query === undefined) {
        throw new RequiredError(
          "query",
          "Required parameter query was null or undefined when calling customerGetAllFiltered."
        );
      }
      const localVarPath = `/jobs/filter`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"CustomerQuery" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(query || {})
        : query || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get job properties
     * @summary Get job
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetJob(id: string, options: any = {}): FetchArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          "id",
          "Required parameter id was null or undefined when calling customerGetJob."
        );
      }
      const localVarPath = `/jobs/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get time and price estimation according to job specifications and preferences
     * @summary Get time and price estimation
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetJobEstimation(id: string, options: any = {}): FetchArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          "id",
          "Required parameter id was null or undefined when calling customerGetJobEstimation."
        );
      }
      const localVarPath = `/jobs/estimation/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get available job presets for a job template
     * @summary Get available job presets
     * @param {string} jobTemplateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetJobPresets(jobTemplateId: string, options: any = {}): FetchArgs {
      // verify required parameter 'jobTemplateId' is not null or undefined
      if (jobTemplateId === null || jobTemplateId === undefined) {
        throw new RequiredError(
          "jobTemplateId",
          "Required parameter jobTemplateId was null or undefined when calling customerGetJobPresets."
        );
      }
      const localVarPath = `/jobs/templates/{jobTemplateId}/presets`.replace(
        `{${"jobTemplateId"}}`,
        encodeURIComponent(String(jobTemplateId))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get job results
     * @summary Get results
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetJobResults(id: string, options: any = {}): FetchArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          "id",
          "Required parameter id was null or undefined when calling customerGetJobResults."
        );
      }
      const localVarPath = `/jobs/{id}/results`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get available job templates
     * @summary Get available job templates
     * @param {number} [paginationLimit]
     * @param {number} [paginationOffset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetJobTemplates(
      paginationLimit?: number,
      paginationOffset?: number,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/jobs/templates`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (paginationLimit !== undefined) {
        localVarQueryParameter["pagination.limit"] = paginationLimit;
      }

      if (paginationOffset !== undefined) {
        localVarQueryParameter["pagination.offset"] = paginationOffset;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get the number of running tasks for the jobs
     * @summary Get the number of running tasks for the jobs
     * @param {CustomerJobsRunningTasksRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetJobsRunningTasks(
      body: CustomerJobsRunningTasksRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling customerGetJobsRunningTasks."
        );
      }
      const localVarPath = `/jobs/runningTasks`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"CustomerJobsRunningTasksRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Run a job
     * @summary Run a job
     * @param {string} jobId
     * @param {JobsRunJobParams} params
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerRunJob(
      jobId: string,
      params: JobsRunJobParams,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'jobId' is not null or undefined
      if (jobId === null || jobId === undefined) {
        throw new RequiredError(
          "jobId",
          "Required parameter jobId was null or undefined when calling customerRunJob."
        );
      }
      // verify required parameter 'params' is not null or undefined
      if (params === null || params === undefined) {
        throw new RequiredError(
          "params",
          "Required parameter params was null or undefined when calling customerRunJob."
        );
      }
      const localVarPath = `/jobs/{jobId}/run`.replace(
        `{${"jobId"}}`,
        encodeURIComponent(String(jobId))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"JobsRunJobParams" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(params || {})
        : params || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Set a job datasource
     * @summary Set a job datasource
     * @param {string} jobId
     * @param {JobsDataSourceParams} params
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerSetJobDataSource(
      jobId: string,
      params: JobsDataSourceParams,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'jobId' is not null or undefined
      if (jobId === null || jobId === undefined) {
        throw new RequiredError(
          "jobId",
          "Required parameter jobId was null or undefined when calling customerSetJobDataSource."
        );
      }
      // verify required parameter 'params' is not null or undefined
      if (params === null || params === undefined) {
        throw new RequiredError(
          "params",
          "Required parameter params was null or undefined when calling customerSetJobDataSource."
        );
      }
      const localVarPath = `/jobs/{jobId}/datasource/`.replace(
        `{${"jobId"}}`,
        encodeURIComponent(String(jobId))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "PATCH" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"JobsDataSourceParams" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(params || {})
        : params || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Set a job name
     * @summary Set a job name
     * @param {string} jobId
     * @param {string} jobName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerSetJobName(
      jobId: string,
      jobName: string,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'jobId' is not null or undefined
      if (jobId === null || jobId === undefined) {
        throw new RequiredError(
          "jobId",
          "Required parameter jobId was null or undefined when calling customerSetJobName."
        );
      }
      // verify required parameter 'jobName' is not null or undefined
      if (jobName === null || jobName === undefined) {
        throw new RequiredError(
          "jobName",
          "Required parameter jobName was null or undefined when calling customerSetJobName."
        );
      }
      const localVarPath = `/jobs/jobname/{jobId}`.replace(
        `{${"jobId"}}`,
        encodeURIComponent(String(jobId))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"string" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(jobName || {})
        : jobName || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Set or update job specific parameters
     * @summary Set job parameters
     * @param {string} jobId
     * @param {JobAppParams} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerSetJobParams(
      jobId: string,
      data: JobAppParams,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'jobId' is not null or undefined
      if (jobId === null || jobId === undefined) {
        throw new RequiredError(
          "jobId",
          "Required parameter jobId was null or undefined when calling customerSetJobParams."
        );
      }
      // verify required parameter 'data' is not null or undefined
      if (data === null || data === undefined) {
        throw new RequiredError(
          "data",
          "Required parameter data was null or undefined when calling customerSetJobParams."
        );
      }
      const localVarPath = `/jobs/params/{jobId}`.replace(
        `{${"jobId"}}`,
        encodeURIComponent(String(jobId))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"JobAppParams" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(data || {})
        : data || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Set or update execution parameters
     * @summary Set job preferences
     * @param {string} jobId
     * @param {JobJobConfig} jobConfig
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerSetJobPreferences(
      jobId: string,
      jobConfig: JobJobConfig,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'jobId' is not null or undefined
      if (jobId === null || jobId === undefined) {
        throw new RequiredError(
          "jobId",
          "Required parameter jobId was null or undefined when calling customerSetJobPreferences."
        );
      }
      // verify required parameter 'jobConfig' is not null or undefined
      if (jobConfig === null || jobConfig === undefined) {
        throw new RequiredError(
          "jobConfig",
          "Required parameter jobConfig was null or undefined when calling customerSetJobPreferences."
        );
      }
      const localVarPath = `/jobs/preferences/{jobId}`.replace(
        `{${"jobId"}}`,
        encodeURIComponent(String(jobId))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"JobJobConfig" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(jobConfig || {})
        : jobConfig || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Set a job local file upload completed
     * @summary Set upload completed
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerSetUploadCompleted(id: string, options: any = {}): FetchArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          "id",
          "Required parameter id was null or undefined when calling customerSetUploadCompleted."
        );
      }
      const localVarPath = `/jobs/uploadcompleted/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * JobsApi - functional programming interface
 * @export
 */
export const JobsApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Abort running job (an incomplete job that is yet to start will be deleted)
     * @summary Stop a running job
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerAbortJob(
      id: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<CommonGenericResponse> {
      const localVarFetchArgs = JobsApiFetchParamCreator(
        configuration
      ).customerAbortJob(id, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Create a job a new job with given template
     * @summary Create a new job
     * @param {JobsCreateJobRequest} body If job id already exists and the request hasn&#39;t started the job record is updated, if job id is null a new id is generated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerCreateJob(
      body: JobsCreateJobRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<JobsJobResponse> {
      const localVarFetchArgs = JobsApiFetchParamCreator(
        configuration
      ).customerCreateJob(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Get info about a data source
     * @summary Get info about a data source
     * @param {JobsDataSourceInfoRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerDataSourceInfo(
      body: JobsDataSourceInfoRequest,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<JobsDataSourceInfoResponse> {
      const localVarFetchArgs = JobsApiFetchParamCreator(
        configuration
      ).customerDataSourceInfo(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Delete a job
     * @summary Delete a job
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerDeleteJob(
      id: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<CommonGenericResponse> {
      const localVarFetchArgs = JobsApiFetchParamCreator(
        configuration
      ).customerDeleteJob(id, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Get all jobs for user
     * @summary Get jobs
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetAll(
      limit?: number,
      offset?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<JobsJobsResponse> {
      const localVarFetchArgs = JobsApiFetchParamCreator(
        configuration
      ).customerGetAll(limit, offset, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Get all jobs for user and filter them
     * @summary Get jobs filtered
     * @param {CustomerQuery} query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetAllFiltered(
      query: CustomerQuery,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<JobsJobsResponse> {
      const localVarFetchArgs = JobsApiFetchParamCreator(
        configuration
      ).customerGetAllFiltered(query, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Get job properties
     * @summary Get job
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetJob(
      id: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<JobsJobResponse> {
      const localVarFetchArgs = JobsApiFetchParamCreator(
        configuration
      ).customerGetJob(id, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Get time and price estimation according to job specifications and preferences
     * @summary Get time and price estimation
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetJobEstimation(
      id: string,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<JobsJobEstimationResponse> {
      const localVarFetchArgs = JobsApiFetchParamCreator(
        configuration
      ).customerGetJobEstimation(id, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Get available job presets for a job template
     * @summary Get available job presets
     * @param {string} jobTemplateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetJobPresets(
      jobTemplateId: string,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<JobsJobPresetsResponse> {
      const localVarFetchArgs = JobsApiFetchParamCreator(
        configuration
      ).customerGetJobPresets(jobTemplateId, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Get job results
     * @summary Get results
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetJobResults(
      id: string,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<JobsJobResultsResponse> {
      const localVarFetchArgs = JobsApiFetchParamCreator(
        configuration
      ).customerGetJobResults(id, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Get available job templates
     * @summary Get available job templates
     * @param {number} [paginationLimit]
     * @param {number} [paginationOffset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetJobTemplates(
      paginationLimit?: number,
      paginationOffset?: number,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<JobsJobTemplatesResponse> {
      const localVarFetchArgs = JobsApiFetchParamCreator(
        configuration
      ).customerGetJobTemplates(paginationLimit, paginationOffset, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Get the number of running tasks for the jobs
     * @summary Get the number of running tasks for the jobs
     * @param {CustomerJobsRunningTasksRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetJobsRunningTasks(
      body: CustomerJobsRunningTasksRequest,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<CustomerJobsRunningTasksResponse> {
      const localVarFetchArgs = JobsApiFetchParamCreator(
        configuration
      ).customerGetJobsRunningTasks(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Run a job
     * @summary Run a job
     * @param {string} jobId
     * @param {JobsRunJobParams} params
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerRunJob(
      jobId: string,
      params: JobsRunJobParams,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<CommonGenericResponse> {
      const localVarFetchArgs = JobsApiFetchParamCreator(
        configuration
      ).customerRunJob(jobId, params, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Set a job datasource
     * @summary Set a job datasource
     * @param {string} jobId
     * @param {JobsDataSourceParams} params
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerSetJobDataSource(
      jobId: string,
      params: JobsDataSourceParams,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<JobsJobResponse> {
      const localVarFetchArgs = JobsApiFetchParamCreator(
        configuration
      ).customerSetJobDataSource(jobId, params, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Set a job name
     * @summary Set a job name
     * @param {string} jobId
     * @param {string} jobName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerSetJobName(
      jobId: string,
      jobName: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<JobsJobResponse> {
      const localVarFetchArgs = JobsApiFetchParamCreator(
        configuration
      ).customerSetJobName(jobId, jobName, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Set or update job specific parameters
     * @summary Set job parameters
     * @param {string} jobId
     * @param {JobAppParams} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerSetJobParams(
      jobId: string,
      data: JobAppParams,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<JobsJobResponse> {
      const localVarFetchArgs = JobsApiFetchParamCreator(
        configuration
      ).customerSetJobParams(jobId, data, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Set or update execution parameters
     * @summary Set job preferences
     * @param {string} jobId
     * @param {JobJobConfig} jobConfig
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerSetJobPreferences(
      jobId: string,
      jobConfig: JobJobConfig,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<JobsJobResponse> {
      const localVarFetchArgs = JobsApiFetchParamCreator(
        configuration
      ).customerSetJobPreferences(jobId, jobConfig, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Set a job local file upload completed
     * @summary Set upload completed
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerSetUploadCompleted(
      id: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<CommonGenericResponse> {
      const localVarFetchArgs = JobsApiFetchParamCreator(
        configuration
      ).customerSetUploadCompleted(id, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
  };
};

/**
 * JobsApi - factory interface
 * @export
 */
export const JobsApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     * Abort running job (an incomplete job that is yet to start will be deleted)
     * @summary Stop a running job
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerAbortJob(id: string, options?: any) {
      return JobsApiFp(configuration).customerAbortJob(id, options)(
        fetch,
        basePath
      );
    },
    /**
     * Create a job a new job with given template
     * @summary Create a new job
     * @param {JobsCreateJobRequest} body If job id already exists and the request hasn&#39;t started the job record is updated, if job id is null a new id is generated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerCreateJob(body: JobsCreateJobRequest, options?: any) {
      return JobsApiFp(configuration).customerCreateJob(body, options)(
        fetch,
        basePath
      );
    },
    /**
     * Get info about a data source
     * @summary Get info about a data source
     * @param {JobsDataSourceInfoRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerDataSourceInfo(body: JobsDataSourceInfoRequest, options?: any) {
      return JobsApiFp(configuration).customerDataSourceInfo(body, options)(
        fetch,
        basePath
      );
    },
    /**
     * Delete a job
     * @summary Delete a job
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerDeleteJob(id: string, options?: any) {
      return JobsApiFp(configuration).customerDeleteJob(id, options)(
        fetch,
        basePath
      );
    },
    /**
     * Get all jobs for user
     * @summary Get jobs
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetAll(limit?: number, offset?: number, options?: any) {
      return JobsApiFp(configuration).customerGetAll(
        limit,
        offset,
        options
      )(fetch, basePath);
    },
    /**
     * Get all jobs for user and filter them
     * @summary Get jobs filtered
     * @param {CustomerQuery} query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetAllFiltered(query: CustomerQuery, options?: any) {
      return JobsApiFp(configuration).customerGetAllFiltered(query, options)(
        fetch,
        basePath
      );
    },
    /**
     * Get job properties
     * @summary Get job
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetJob(id: string, options?: any) {
      return JobsApiFp(configuration).customerGetJob(id, options)(
        fetch,
        basePath
      );
    },
    /**
     * Get time and price estimation according to job specifications and preferences
     * @summary Get time and price estimation
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetJobEstimation(id: string, options?: any) {
      return JobsApiFp(configuration).customerGetJobEstimation(id, options)(
        fetch,
        basePath
      );
    },
    /**
     * Get available job presets for a job template
     * @summary Get available job presets
     * @param {string} jobTemplateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetJobPresets(jobTemplateId: string, options?: any) {
      return JobsApiFp(configuration).customerGetJobPresets(
        jobTemplateId,
        options
      )(fetch, basePath);
    },
    /**
     * Get job results
     * @summary Get results
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetJobResults(id: string, options?: any) {
      return JobsApiFp(configuration).customerGetJobResults(id, options)(
        fetch,
        basePath
      );
    },
    /**
     * Get available job templates
     * @summary Get available job templates
     * @param {number} [paginationLimit]
     * @param {number} [paginationOffset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetJobTemplates(
      paginationLimit?: number,
      paginationOffset?: number,
      options?: any
    ) {
      return JobsApiFp(configuration).customerGetJobTemplates(
        paginationLimit,
        paginationOffset,
        options
      )(fetch, basePath);
    },
    /**
     * Get the number of running tasks for the jobs
     * @summary Get the number of running tasks for the jobs
     * @param {CustomerJobsRunningTasksRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetJobsRunningTasks(
      body: CustomerJobsRunningTasksRequest,
      options?: any
    ) {
      return JobsApiFp(configuration).customerGetJobsRunningTasks(
        body,
        options
      )(fetch, basePath);
    },
    /**
     * Run a job
     * @summary Run a job
     * @param {string} jobId
     * @param {JobsRunJobParams} params
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerRunJob(jobId: string, params: JobsRunJobParams, options?: any) {
      return JobsApiFp(configuration).customerRunJob(
        jobId,
        params,
        options
      )(fetch, basePath);
    },
    /**
     * Set a job datasource
     * @summary Set a job datasource
     * @param {string} jobId
     * @param {JobsDataSourceParams} params
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerSetJobDataSource(
      jobId: string,
      params: JobsDataSourceParams,
      options?: any
    ) {
      return JobsApiFp(configuration).customerSetJobDataSource(
        jobId,
        params,
        options
      )(fetch, basePath);
    },
    /**
     * Set a job name
     * @summary Set a job name
     * @param {string} jobId
     * @param {string} jobName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerSetJobName(jobId: string, jobName: string, options?: any) {
      return JobsApiFp(configuration).customerSetJobName(
        jobId,
        jobName,
        options
      )(fetch, basePath);
    },
    /**
     * Set or update job specific parameters
     * @summary Set job parameters
     * @param {string} jobId
     * @param {JobAppParams} data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerSetJobParams(jobId: string, data: JobAppParams, options?: any) {
      return JobsApiFp(configuration).customerSetJobParams(
        jobId,
        data,
        options
      )(fetch, basePath);
    },
    /**
     * Set or update execution parameters
     * @summary Set job preferences
     * @param {string} jobId
     * @param {JobJobConfig} jobConfig
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerSetJobPreferences(
      jobId: string,
      jobConfig: JobJobConfig,
      options?: any
    ) {
      return JobsApiFp(configuration).customerSetJobPreferences(
        jobId,
        jobConfig,
        options
      )(fetch, basePath);
    },
    /**
     * Set a job local file upload completed
     * @summary Set upload completed
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerSetUploadCompleted(id: string, options?: any) {
      return JobsApiFp(configuration).customerSetUploadCompleted(id, options)(
        fetch,
        basePath
      );
    },
  };
};

/**
 * JobsApi - object-oriented interface
 * @export
 * @class JobsApi
 * @extends {BaseAPI}
 */
export class JobsApi extends BaseAPI {
  /**
   * Abort running job (an incomplete job that is yet to start will be deleted)
   * @summary Stop a running job
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JobsApi
   */
  public customerAbortJob(id: string, options?: any) {
    return JobsApiFp(this.configuration).customerAbortJob(id, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   * Create a job a new job with given template
   * @summary Create a new job
   * @param {JobsCreateJobRequest} body If job id already exists and the request hasn&#39;t started the job record is updated, if job id is null a new id is generated.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JobsApi
   */
  public customerCreateJob(body: JobsCreateJobRequest, options?: any) {
    return JobsApiFp(this.configuration).customerCreateJob(body, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   * Get info about a data source
   * @summary Get info about a data source
   * @param {JobsDataSourceInfoRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JobsApi
   */
  public customerDataSourceInfo(
    body: JobsDataSourceInfoRequest,
    options?: any
  ) {
    return JobsApiFp(this.configuration).customerDataSourceInfo(body, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   * Delete a job
   * @summary Delete a job
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JobsApi
   */
  public customerDeleteJob(id: string, options?: any) {
    return JobsApiFp(this.configuration).customerDeleteJob(id, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   * Get all jobs for user
   * @summary Get jobs
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JobsApi
   */
  public customerGetAll(limit?: number, offset?: number, options?: any) {
    return JobsApiFp(this.configuration).customerGetAll(
      limit,
      offset,
      options
    )(this.fetch, this.basePath);
  }

  /**
   * Get all jobs for user and filter them
   * @summary Get jobs filtered
   * @param {CustomerQuery} query
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JobsApi
   */
  public customerGetAllFiltered(query: CustomerQuery, options?: any) {
    return JobsApiFp(this.configuration).customerGetAllFiltered(query, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   * Get job properties
   * @summary Get job
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JobsApi
   */
  public customerGetJob(id: string, options?: any) {
    return JobsApiFp(this.configuration).customerGetJob(id, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   * Get time and price estimation according to job specifications and preferences
   * @summary Get time and price estimation
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JobsApi
   */
  public customerGetJobEstimation(id: string, options?: any) {
    return JobsApiFp(this.configuration).customerGetJobEstimation(id, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   * Get available job presets for a job template
   * @summary Get available job presets
   * @param {string} jobTemplateId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JobsApi
   */
  public customerGetJobPresets(jobTemplateId: string, options?: any) {
    return JobsApiFp(this.configuration).customerGetJobPresets(
      jobTemplateId,
      options
    )(this.fetch, this.basePath);
  }

  /**
   * Get job results
   * @summary Get results
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JobsApi
   */
  public customerGetJobResults(id: string, options?: any) {
    return JobsApiFp(this.configuration).customerGetJobResults(id, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   * Get available job templates
   * @summary Get available job templates
   * @param {number} [paginationLimit]
   * @param {number} [paginationOffset]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JobsApi
   */
  public customerGetJobTemplates(
    paginationLimit?: number,
    paginationOffset?: number,
    options?: any
  ) {
    return JobsApiFp(this.configuration).customerGetJobTemplates(
      paginationLimit,
      paginationOffset,
      options
    )(this.fetch, this.basePath);
  }

  /**
   * Get the number of running tasks for the jobs
   * @summary Get the number of running tasks for the jobs
   * @param {CustomerJobsRunningTasksRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JobsApi
   */
  public customerGetJobsRunningTasks(
    body: CustomerJobsRunningTasksRequest,
    options?: any
  ) {
    return JobsApiFp(this.configuration).customerGetJobsRunningTasks(
      body,
      options
    )(this.fetch, this.basePath);
  }

  /**
   * Run a job
   * @summary Run a job
   * @param {string} jobId
   * @param {JobsRunJobParams} params
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JobsApi
   */
  public customerRunJob(
    jobId: string,
    params: JobsRunJobParams,
    options?: any
  ) {
    return JobsApiFp(this.configuration).customerRunJob(
      jobId,
      params,
      options
    )(this.fetch, this.basePath);
  }

  /**
   * Set a job datasource
   * @summary Set a job datasource
   * @param {string} jobId
   * @param {JobsDataSourceParams} params
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JobsApi
   */
  public customerSetJobDataSource(
    jobId: string,
    params: JobsDataSourceParams,
    options?: any
  ) {
    return JobsApiFp(this.configuration).customerSetJobDataSource(
      jobId,
      params,
      options
    )(this.fetch, this.basePath);
  }

  /**
   * Set a job name
   * @summary Set a job name
   * @param {string} jobId
   * @param {string} jobName
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JobsApi
   */
  public customerSetJobName(jobId: string, jobName: string, options?: any) {
    return JobsApiFp(this.configuration).customerSetJobName(
      jobId,
      jobName,
      options
    )(this.fetch, this.basePath);
  }

  /**
   * Set or update job specific parameters
   * @summary Set job parameters
   * @param {string} jobId
   * @param {JobAppParams} data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JobsApi
   */
  public customerSetJobParams(
    jobId: string,
    data: JobAppParams,
    options?: any
  ) {
    return JobsApiFp(this.configuration).customerSetJobParams(
      jobId,
      data,
      options
    )(this.fetch, this.basePath);
  }

  /**
   * Set or update execution parameters
   * @summary Set job preferences
   * @param {string} jobId
   * @param {JobJobConfig} jobConfig
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JobsApi
   */
  public customerSetJobPreferences(
    jobId: string,
    jobConfig: JobJobConfig,
    options?: any
  ) {
    return JobsApiFp(this.configuration).customerSetJobPreferences(
      jobId,
      jobConfig,
      options
    )(this.fetch, this.basePath);
  }

  /**
   * Set a job local file upload completed
   * @summary Set upload completed
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JobsApi
   */
  public customerSetUploadCompleted(id: string, options?: any) {
    return JobsApiFp(this.configuration).customerSetUploadCompleted(
      id,
      options
    )(this.fetch, this.basePath);
  }
}

/**
 * SchemaApi - fetch parameter creator
 * @export
 */
export const SchemaApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Get schema by id and version
     * @summary Get job schema
     * @param {string} id
     * @param {string} [version]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetSchema(
      id: string,
      version?: string,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          "id",
          "Required parameter id was null or undefined when calling customerGetSchema."
        );
      }
      const localVarPath = `/schema/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (version !== undefined) {
        localVarQueryParameter["version"] = version;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SchemaApi - functional programming interface
 * @export
 */
export const SchemaApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Get schema by id and version
     * @summary Get job schema
     * @param {string} id
     * @param {string} [version]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetSchema(
      id: string,
      version?: string,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<CustomerSchemaResponse> {
      const localVarFetchArgs = SchemaApiFetchParamCreator(
        configuration
      ).customerGetSchema(id, version, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
  };
};

/**
 * SchemaApi - factory interface
 * @export
 */
export const SchemaApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     * Get schema by id and version
     * @summary Get job schema
     * @param {string} id
     * @param {string} [version]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetSchema(id: string, version?: string, options?: any) {
      return SchemaApiFp(configuration).customerGetSchema(
        id,
        version,
        options
      )(fetch, basePath);
    },
  };
};

/**
 * SchemaApi - object-oriented interface
 * @export
 * @class SchemaApi
 * @extends {BaseAPI}
 */
export class SchemaApi extends BaseAPI {
  /**
   * Get schema by id and version
   * @summary Get job schema
   * @param {string} id
   * @param {string} [version]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SchemaApi
   */
  public customerGetSchema(id: string, version?: string, options?: any) {
    return SchemaApiFp(this.configuration).customerGetSchema(
      id,
      version,
      options
    )(this.fetch, this.basePath);
  }
}

/**
 * StatsApi - fetch parameter creator
 * @export
 */
export const StatsApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Get existing job types
     * @summary Get all existing job types (video, ml,...)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetJobTypes(options: any = {}): FetchArgs {
      const localVarPath = `/stats/job_types`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get statistics of the last month
     * @summary Get statistics of the last month
     * @param {StatsOverviewStatsRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetOverviewStats(
      body: StatsOverviewStatsRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling customerGetOverviewStats."
        );
      }
      const localVarPath = `/stats/overview`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"StatsOverviewStatsRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get available job templates
     * @summary Get available job templates
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetStatsForJobType(id: string, options: any = {}): FetchArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          "id",
          "Required parameter id was null or undefined when calling customerGetStatsForJobType."
        );
      }
      const localVarPath = `/stats/detail/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * StatsApi - functional programming interface
 * @export
 */
export const StatsApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Get existing job types
     * @summary Get all existing job types (video, ml,...)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetJobTypes(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<StatsJobTypesResponse> {
      const localVarFetchArgs =
        StatsApiFetchParamCreator(configuration).customerGetJobTypes(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Get statistics of the last month
     * @summary Get statistics of the last month
     * @param {StatsOverviewStatsRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetOverviewStats(
      body: StatsOverviewStatsRequest,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<StatsOverviewStatsResponse> {
      const localVarFetchArgs = StatsApiFetchParamCreator(
        configuration
      ).customerGetOverviewStats(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Get available job templates
     * @summary Get available job templates
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetStatsForJobType(
      id: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<StatsJobStatsResponse> {
      const localVarFetchArgs = StatsApiFetchParamCreator(
        configuration
      ).customerGetStatsForJobType(id, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
  };
};

/**
 * StatsApi - factory interface
 * @export
 */
export const StatsApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     * Get existing job types
     * @summary Get all existing job types (video, ml,...)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetJobTypes(options?: any) {
      return StatsApiFp(configuration).customerGetJobTypes(options)(
        fetch,
        basePath
      );
    },
    /**
     * Get statistics of the last month
     * @summary Get statistics of the last month
     * @param {StatsOverviewStatsRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetOverviewStats(body: StatsOverviewStatsRequest, options?: any) {
      return StatsApiFp(configuration).customerGetOverviewStats(body, options)(
        fetch,
        basePath
      );
    },
    /**
     * Get available job templates
     * @summary Get available job templates
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetStatsForJobType(id: string, options?: any) {
      return StatsApiFp(configuration).customerGetStatsForJobType(id, options)(
        fetch,
        basePath
      );
    },
  };
};

/**
 * StatsApi - object-oriented interface
 * @export
 * @class StatsApi
 * @extends {BaseAPI}
 */
export class StatsApi extends BaseAPI {
  /**
   * Get existing job types
   * @summary Get all existing job types (video, ml,...)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatsApi
   */
  public customerGetJobTypes(options?: any) {
    return StatsApiFp(this.configuration).customerGetJobTypes(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   * Get statistics of the last month
   * @summary Get statistics of the last month
   * @param {StatsOverviewStatsRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatsApi
   */
  public customerGetOverviewStats(
    body: StatsOverviewStatsRequest,
    options?: any
  ) {
    return StatsApiFp(this.configuration).customerGetOverviewStats(
      body,
      options
    )(this.fetch, this.basePath);
  }

  /**
   * Get available job templates
   * @summary Get available job templates
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatsApi
   */
  public customerGetStatsForJobType(id: string, options?: any) {
    return StatsApiFp(this.configuration).customerGetStatsForJobType(
      id,
      options
    )(this.fetch, this.basePath);
  }
}

/**
 * WalletApi - fetch parameter creator
 * @export
 */
export const WalletApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Cancel a subscription
     * @summary Cancel a subscription
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerCancelSubscription(id: string, options: any = {}): FetchArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          "id",
          "Required parameter id was null or undefined when calling customerCancelSubscription."
        );
      }
      const localVarPath = `/subscriptions/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "DELETE" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Cancel a top up request and update state
     * @summary Cancel a topup request
     * @param {CustomerCancelTopUpRequestParams} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerCancelTopUpRequest(
      body: CustomerCancelTopUpRequestParams,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling customerCancelTopUpRequest."
        );
      }
      const localVarPath = `/cancel_top_up`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"CustomerCancelTopUpRequestParams" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Create a new subscription
     * @summary Create a new subscription
     * @param {WalletCreateSubscriptionRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerCreateSubscription(
      body: WalletCreateSubscriptionRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling customerCreateSubscription."
        );
      }
      const localVarPath = `/subscriptions`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"WalletCreateSubscriptionRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Create a top up request and get the payment code
     * @summary Create a new topup request
     * @param {CustomerTopUpRequestParams} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerCreateTopUpRequest(
      body: CustomerTopUpRequestParams,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling customerCreateTopUpRequest."
        );
      }
      const localVarPath = `/top_up`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"CustomerTopUpRequestParams" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Retrieve the active subscription
     * @summary Retrieve the active subscription
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetActiveSubscription(options: any = {}): FetchArgs {
      const localVarPath = `/subscriptions/active`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get wallet balance for current user
     * @summary Get wallet balance
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetBalance(options: any = {}): FetchArgs {
      const localVarPath = `/balance`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Convert amount from currency to ByteChips
     * @summary Get exchange rate in ByteChips for a currency
     * @param {string} [currency]
     * @param {string} [currencyAmount]
     * @param {string} [amount]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetExchangeRate(
      currency?: string,
      currencyAmount?: string,
      amount?: string,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/exchange_rate`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (currency !== undefined) {
        localVarQueryParameter["currency"] = currency;
      }

      if (currencyAmount !== undefined) {
        localVarQueryParameter["currencyAmount"] = currencyAmount;
      }

      if (amount !== undefined) {
        localVarQueryParameter["amount"] = amount;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Retrieve available subscription plans
     * @summary Retrieve subscription plans
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetPlans(options: any = {}): FetchArgs {
      const localVarPath = `/plans`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get paginated list of transactions
     * @summary Get transaction history
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetTransactionList(body: any, options: any = {}): FetchArgs {
      const localVarPath = `/transactions/filter`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      localVarRequestOptions.body = JSON.stringify(body);
      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Retrieve paginated payout history for current user
     * @summary Retrieve payout history
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerPayoutHistory(
      limit?: number,
      offset?: number,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/payout_history`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Redeem a promo code
     * @summary Redeem promo code
     * @param {WalletRedeemCouponRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerRedeemCoupon(
      body: WalletRedeemCouponRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling customerRedeemCoupon."
        );
      }
      const localVarPath = `/redeem_coupon`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"WalletRedeemCouponRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Require a cash payout or swap credit for prizes
     * @summary Require a payout
     * @param {WalletPayoutRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerRequirePayout(
      body: WalletPayoutRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling customerRequirePayout."
        );
      }
      const localVarPath = `/payout`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"WalletPayoutRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Change a subscription plan
     * @summary Update a subscription
     * @param {string} id
     * @param {UpdateSubscriptionRequestUpdateSubscriptionRequestBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerUpdateSubscription(
      id: string,
      body: UpdateSubscriptionRequestUpdateSubscriptionRequestBody,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          "id",
          "Required parameter id was null or undefined when calling customerUpdateSubscription."
        );
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling customerUpdateSubscription."
        );
      }
      const localVarPath = `/subscriptions/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"UpdateSubscriptionRequestUpdateSubscriptionRequestBody" !==
          "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get paginated list of transactions
     * @summary Get transaction history
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetBillingUrl(options: any = {}): FetchArgs {
      const localVarPath = `/billing_portal`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    customerGetTransactionHistory(body: any, options: any = {}): FetchArgs {
      const localVarPath = `/transactions/filter`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      localVarRequestOptions.body = JSON.stringify(body);
      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    customerGetAllTransactionCsv(): FetchArgs {
      const localVarPath = `/transactions/csv`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" });
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === "function"
            ? configuration.apiKey("Authorization")
            : configuration.apiKey;
        localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter
      );
      // localVarRequestOptions.body=JSON.stringify(body)
      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * WalletApi - functional programming interface
 * @export
 */
export const WalletApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Cancel a subscription
     * @summary Cancel a subscription
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerCancelSubscription(
      id: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<CommonGenericResponse> {
      const localVarFetchArgs = WalletApiFetchParamCreator(
        configuration
      ).customerCancelSubscription(id, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Cancel a top up request and update state
     * @summary Cancel a topup request
     * @param {CustomerCancelTopUpRequestParams} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerCancelTopUpRequest(
      body: CustomerCancelTopUpRequestParams,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<CommonGenericResponse> {
      const localVarFetchArgs = WalletApiFetchParamCreator(
        configuration
      ).customerCancelTopUpRequest(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Create a new subscription
     * @summary Create a new subscription
     * @param {WalletCreateSubscriptionRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerCreateSubscription(
      body: WalletCreateSubscriptionRequest,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<WalletCreateSubscriptionResponse> {
      const localVarFetchArgs = WalletApiFetchParamCreator(
        configuration
      ).customerCreateSubscription(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Create a top up request and get the payment code
     * @summary Create a new topup request
     * @param {CustomerTopUpRequestParams} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerCreateTopUpRequest(
      body: CustomerTopUpRequestParams,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<WalletTopUpResponse> {
      const localVarFetchArgs = WalletApiFetchParamCreator(
        configuration
      ).customerCreateTopUpRequest(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Retrieve the active subscription
     * @summary Retrieve the active subscription
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetActiveSubscription(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<WalletSubscription> {
      const localVarFetchArgs =
        WalletApiFetchParamCreator(configuration).customerGetActiveSubscription(
          options
        );
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Get wallet balance for current user
     * @summary Get wallet balance
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetBalance(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<WalletGetBalanceResponse> {
      const localVarFetchArgs =
        WalletApiFetchParamCreator(configuration).customerGetBalance(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Convert amount from currency to ByteChips
     * @summary Get exchange rate in ByteChips for a currency
     * @param {string} [currency]
     * @param {string} [currencyAmount]
     * @param {string} [amount]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetExchangeRate(
      currency?: string,
      currencyAmount?: string,
      amount?: string,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<WalletExchangeRateResponse> {
      const localVarFetchArgs = WalletApiFetchParamCreator(
        configuration
      ).customerGetExchangeRate(currency, currencyAmount, amount, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Retrieve available subscription plans
     * @summary Retrieve subscription plans
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetPlans(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<WalletListPlansResponse> {
      const localVarFetchArgs =
        WalletApiFetchParamCreator(configuration).customerGetPlans(options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Get paginated list of transactions
     * @summary Get transaction history
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetTransactionList(
      body: any,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<WalletTransactionHistoryResponse> {
      const localVarFetchArgs = WalletApiFetchParamCreator(
        configuration
      ).customerGetTransactionList(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Retrieve paginated payout history for current user
     * @summary Retrieve payout history
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerPayoutHistory(
      limit?: number,
      offset?: number,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<WalletPayoutRequestFilterResponse> {
      const localVarFetchArgs = WalletApiFetchParamCreator(
        configuration
      ).customerPayoutHistory(limit, offset, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Redeem a promo code
     * @summary Redeem promo code
     * @param {WalletRedeemCouponRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerRedeemCoupon(
      body: WalletRedeemCouponRequest,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<CustomerRedeemCouponResponse> {
      const localVarFetchArgs = WalletApiFetchParamCreator(
        configuration
      ).customerRedeemCoupon(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Require a cash payout or swap credit for prizes
     * @summary Require a payout
     * @param {WalletPayoutRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerRequirePayout(
      body: WalletPayoutRequest,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<WalletRequirePayoutResponse> {
      const localVarFetchArgs = WalletApiFetchParamCreator(
        configuration
      ).customerRequirePayout(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Change a subscription plan
     * @summary Update a subscription
     * @param {string} id
     * @param {UpdateSubscriptionRequestUpdateSubscriptionRequestBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerUpdateSubscription(
      id: string,
      body: UpdateSubscriptionRequestUpdateSubscriptionRequestBody,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<WalletCreateSubscriptionResponse> {
      const localVarFetchArgs = WalletApiFetchParamCreator(
        configuration
      ).customerUpdateSubscription(id, body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Get paginated list of transactions
     * @summary Get transaction history
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetBillingPortal(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<WalletTransactionHistoryResponse> {
      const localVarFetchArgs =
        WalletApiFetchParamCreator(configuration).customerGetBillingUrl(
          options
        );
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    customerGetTransactionHistory(
      body: any,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
      const localVarFetchArgs = WalletApiFetchParamCreator(
        configuration
      ).customerGetTransactionHistory(body, options);
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    customerGetAllTransactionCsv(): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<any> {
      const localVarFetchArgs =
        WalletApiFetchParamCreator(
          configuration
        ).customerGetAllTransactionCsv();
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
  };
};

/**
 * WalletApi - factory interface
 * @export
 */
export const WalletApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     * Cancel a subscription
     * @summary Cancel a subscription
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerCancelSubscription(id: string, options?: any) {
      return WalletApiFp(configuration).customerCancelSubscription(id, options)(
        fetch,
        basePath
      );
    },
    /**
     * Cancel a top up request and update state
     * @summary Cancel a topup request
     * @param {CustomerCancelTopUpRequestParams} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerCancelTopUpRequest(
      body: CustomerCancelTopUpRequestParams,
      options?: any
    ) {
      return WalletApiFp(configuration).customerCancelTopUpRequest(
        body,
        options
      )(fetch, basePath);
    },
    /**
     * Create a new subscription
     * @summary Create a new subscription
     * @param {WalletCreateSubscriptionRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerCreateSubscription(
      body: WalletCreateSubscriptionRequest,
      options?: any
    ) {
      return WalletApiFp(configuration).customerCreateSubscription(
        body,
        options
      )(fetch, basePath);
    },
    /**
     * Create a top up request and get the payment code
     * @summary Create a new topup request
     * @param {CustomerTopUpRequestParams} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerCreateTopUpRequest(
      body: CustomerTopUpRequestParams,
      options?: any
    ) {
      return WalletApiFp(configuration).customerCreateTopUpRequest(
        body,
        options
      )(fetch, basePath);
    },
    /**
     * Retrieve the active subscription
     * @summary Retrieve the active subscription
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetActiveSubscription(options?: any) {
      return WalletApiFp(configuration).customerGetActiveSubscription(options)(
        fetch,
        basePath
      );
    },
    /**
     * Get wallet balance for current user
     * @summary Get wallet balance
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetBalance(options?: any) {
      return WalletApiFp(configuration).customerGetBalance(options)(
        fetch,
        basePath
      );
    },
    /**
     * Convert amount from currency to ByteChips
     * @summary Get exchange rate in ByteChips for a currency
     * @param {string} [currency]
     * @param {string} [currencyAmount]
     * @param {string} [amount]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetExchangeRate(
      currency?: string,
      currencyAmount?: string,
      amount?: string,
      options?: any
    ) {
      return WalletApiFp(configuration).customerGetExchangeRate(
        currency,
        currencyAmount,
        amount,
        options
      )(fetch, basePath);
    },
    /**
     * Retrieve available subscription plans
     * @summary Retrieve subscription plans
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetPlans(options?: any) {
      return WalletApiFp(configuration).customerGetPlans(options)(
        fetch,
        basePath
      );
    },
    /**
     * Get paginated list of transactions
     * @summary Get transaction history
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerGetTransactionList(options?: any) {
      return WalletApiFp(configuration).customerGetTransactionList(options)(
        fetch,
        basePath
      );
    },
    /**
     * Retrieve paginated payout history for current user
     * @summary Retrieve payout history
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerPayoutHistory(limit?: number, offset?: number, options?: any) {
      return WalletApiFp(configuration).customerPayoutHistory(
        limit,
        offset,
        options
      )(fetch, basePath);
    },
    /**
     * Redeem a promo code
     * @summary Redeem promo code
     * @param {WalletRedeemCouponRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerRedeemCoupon(body: WalletRedeemCouponRequest, options?: any) {
      return WalletApiFp(configuration).customerRedeemCoupon(body, options)(
        fetch,
        basePath
      );
    },
    /**
     * Require a cash payout or swap credit for prizes
     * @summary Require a payout
     * @param {WalletPayoutRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerRequirePayout(body: WalletPayoutRequest, options?: any) {
      return WalletApiFp(configuration).customerRequirePayout(body, options)(
        fetch,
        basePath
      );
    },
    /**
     * Change a subscription plan
     * @summary Update a subscription
     * @param {string} id
     * @param {UpdateSubscriptionRequestUpdateSubscriptionRequestBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerUpdateSubscription(
      id: string,
      body: UpdateSubscriptionRequestUpdateSubscriptionRequestBody,
      options?: any
    ) {
      return WalletApiFp(configuration).customerUpdateSubscription(
        id,
        body,
        options
      )(fetch, basePath);
    },
  };
};

/**
 * WalletApi - object-oriented interface
 * @export
 * @class WalletApi
 * @extends {BaseAPI}
 */
export class WalletApi extends BaseAPI {
  constructor(
    configuration?: Configuration,
    protected basePath: string = BASE_PATH,
    protected fetch: FetchAPI = portableFetch,
    protected walletBasePath: string = WALLET_BASE_PATH
  ) {
    super(configuration);
    this.basePath = this.walletBasePath;
  }

  /**
   * Cancel a subscription
   * @summary Cancel a subscription
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletApi
   */
  public customerCancelSubscription(id: string, options?: any) {
    return WalletApiFp(this.configuration).customerCancelSubscription(
      id,
      options
    )(this.fetch, this.basePath);
  }

  /**
   * Cancel a top up request and update state
   * @summary Cancel a topup request
   * @param {CustomerCancelTopUpRequestParams} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletApi
   */
  public customerCancelTopUpRequest(
    body: CustomerCancelTopUpRequestParams,
    options?: any
  ) {
    return WalletApiFp(this.configuration).customerCancelTopUpRequest(
      body,
      options
    )(this.fetch, this.basePath);
  }

  /**
   * Create a new subscription
   * @summary Create a new subscription
   * @param {WalletCreateSubscriptionRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletApi
   */
  public customerCreateSubscription(
    body: WalletCreateSubscriptionRequest,
    options?: any
  ) {
    return WalletApiFp(this.configuration).customerCreateSubscription(
      body,
      options
    )(this.fetch, this.basePath);
  }

  /**
   * Create a top up request and get the payment code
   * @summary Create a new topup request
   * @param {CustomerTopUpRequestParams} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletApi
   */
  public customerCreateTopUpRequest(
    body: CustomerTopUpRequestParams,
    options?: any
  ) {
    return WalletApiFp(this.configuration).customerCreateTopUpRequest(
      body,
      options
    )(this.fetch, this.basePath);
  }

  /**
   * Retrieve the active subscription
   * @summary Retrieve the active subscription
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletApi
   */
  public customerGetActiveSubscription(options?: any) {
    return WalletApiFp(this.configuration).customerGetActiveSubscription(
      options
    )(this.fetch, this.basePath);
  }

  /**
   * Get wallet balance for current user
   * @summary Get wallet balance
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletApi
   */
  public customerGetBalance(options?: any) {
    return WalletApiFp(this.configuration).customerGetBalance(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   * Convert amount from currency to ByteChips
   * @summary Get exchange rate in ByteChips for a currency
   * @param {string} [currency]
   * @param {string} [currencyAmount]
   * @param {string} [amount]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletApi
   */
  public customerGetExchangeRate(
    currency?: string,
    currencyAmount?: string,
    amount?: string,
    options?: any
  ) {
    return WalletApiFp(this.configuration).customerGetExchangeRate(
      currency,
      currencyAmount,
      amount,
      options
    )(this.fetch, this.basePath);
  }

  /**
   * Retrieve available subscription plans
   * @summary Retrieve subscription plans
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletApi
   */
  public customerGetPlans(options?: any) {
    return WalletApiFp(this.configuration).customerGetPlans(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   * Get paginated list of transactions
   * @summary Get transaction history
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletApi
   */
  public customerGetTransactionList(body: any, options?: any) {
    return WalletApiFp(this.configuration).customerGetTransactionList(
      body,
      options
    )(this.fetch, this.basePath);
  }

  /**
   * Retrieve paginated payout history for current user
   * @summary Retrieve payout history
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletApi
   */
  public customerPayoutHistory(limit?: number, offset?: number, options?: any) {
    return WalletApiFp(this.configuration).customerPayoutHistory(
      limit,
      offset,
      options
    )(this.fetch, this.basePath);
  }

  /**
   * Redeem a promo code
   * @summary Redeem promo code
   * @param {WalletRedeemCouponRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletApi
   */
  public customerRedeemCoupon(body: WalletRedeemCouponRequest, options?: any) {
    return WalletApiFp(this.configuration).customerRedeemCoupon(body, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   * Require a cash payout or swap credit for prizes
   * @summary Require a payout
   * @param {WalletPayoutRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletApi
   */
  public customerRequirePayout(body: WalletPayoutRequest, options?: any) {
    return WalletApiFp(this.configuration).customerRequirePayout(body, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   * Change a subscription plan
   * @summary Update a subscription
   * @param {string} id
   * @param {UpdateSubscriptionRequestUpdateSubscriptionRequestBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletApi
   */
  public customerUpdateSubscription(
    id: string,
    body: UpdateSubscriptionRequestUpdateSubscriptionRequestBody,
    options?: any
  ) {
    return WalletApiFp(this.configuration).customerUpdateSubscription(
      id,
      body,
      options
    )(this.fetch, this.basePath);
  }

  public customerGetBillingPortalLink(options?: any) {
    return WalletApiFp(this.configuration).customerGetBillingPortal(options)(
      this.fetch,
      this.basePath
    );
  }
  public customerGetTransactionHistory(body: any, options?: any) {
    return WalletApiFp(this.configuration).customerGetTransactionHistory(
      body,
      options
    )(this.fetch, this.basePath);
  }
  public customerGetAllTransactionCsv() {
    return WalletApiFp(this.configuration).customerGetAllTransactionCsv()(
      this.fetch,
      this.basePath
    );
  }
}
